class ReadMoreText extends HTMLElement {
  constructor() {
    super();

    this.controllButton = this.querySelector('.show-more-btn-toogle');
    this.content = this.querySelector('.show-more-content');
    this.contentWrapper = this.closest('.show-more-content-wrapper');
    this.readMoreButton = this.querySelector('.read_less');
    this.readLessButton = this.querySelector('.read_less');

    if (!this.controllButton || !this.content || !this.readMoreButton || !this.readLessButton) {
      return;
    }

    this.init();
  }

  init() {
    this.checkVisibility();
  }

  checkVisibility() {
    const heightWraper = this.contentWrapper.offsetHeight;
    const heightContent = this.content.scrollHeight;

    console.log('heightWraper', heightWraper);
    console.log('heightContent', heightContent);

    if (heightContent < heightWraper) {
      return;
    }

    this.controlHideContent();
  }

  controlHideContent() {
    this.controllButton.removeAttribute('hidden');

    this.controllButton.addEventListener('click', (event) => {
      console.log('read more clicked');

      this.content.classList.toggle('opened');
      this.contentWrapper.classList.toggle('opened');

      const buttonAtribute = this.controllButton.getAttribute('aria-expanded');

      if (buttonAtribute === 'true') {
        this.readMoreButton.setAttribute('aria-hidden', 'false');
        this.readLessButton.setAttribute('aria-hidden', 'true');

        return this.controllButton.setAttribute('aria-expanded', 'false');
      }
      
      this.readMoreButton.setAttribute('aria-hidden', 'true');
      this.readLessButton.setAttribute('aria-hidden', 'false');
      this.controllButton.setAttribute('aria-expanded', 'true');
    });
  }
}

customElements.define('read-more-text', ReadMoreText);